<div class="row top_heading" [class.sidebar-collapsed]="isSidebarCollapsed">
  <div class="col-xl-2 ">
    <app-hr-header [employeeHeading]="heading"></app-hr-header>
  </div>
  <div class="col-xl-6 input_email">
    <input 
      [readonly]="searchReadonly"
      type="text" 
      name="search"
      id="search-input" 
      [(ngModel)]="searchQuery"
      (input)="onSearchInput($event)"
      (click)="onSearchFocus()"
      [disabled]="dialogOpen"
      [placeholder]="searchPlaceholder"
    />
    <div class="filter-icon" (click)="onFilterClick()" *ngIf="showFilterIcon"></div>
  </div>
  <div class="col-xl-4">
    <div class="float-end">
 
    <button 
      type="button" 
      class="exportbtn" 
      (click)="onExportClick()"
      *ngIf="showExportButton"
    >
      {{ exportButtonText }}
    </button>

       <button 
      type="button" 
      class="approvebtn" 
      (click)="onAddClick()"
      *ngIf="showAddButton"
    >
      {{ addButtonText }}
    </button>
    </div>
  </div>
</div>